import { makeObservable, observable, computed, action, toJS } from 'mobx';
import router from 'next/router';
import { TFilterSelectOptions } from '@features/categories/typescript';
import { REQUIRED_SORT } from '@features/categories/const';
export default class FilterSortState {
  key = 'sort';
  type = 'select';
  state = '';
  name = '';
  queryName = 'sort';
  options: TFilterSelectOptions = {} as TFilterSelectOptions;
  userActivity = false;
  constructor(sorting: {
    available: unknown;
  }, name: string) {
    makeObservable(this, {
      state: observable,
      name: observable,
      order: computed,
      orderBy: computed,
      queryURLString: computed,
      setValue: action,
      resetValue: action,
      value: computed,
      isSet: computed,
      markUserActivity: action
    });
    this.options = this.createOptions(Array.isArray(sorting.available) && sorting.available.length ? sorting.available[0] : []);
    this.name = name;
    this.state = '';
  }
  get order() {
    return this.value ? this.value.split('_')[1].toUpperCase() : null;
  }
  get orderBy() {
    return this.value.split('_')[0];
  }
  get isSet() {
    return this.state !== '';
  }
  markUserActivity() {
    this.userActivity = true;
  }
  createOptions(available) {
    const newOptions = {};
    available.forEach(sortEl => {
      if (!REQUIRED_SORT.includes(sortEl)) return;
      newOptions[`${sortEl}_desc`] = sortEl;
      newOptions[`${sortEl}_asc`] = sortEl;
    });
    return newOptions;
  }
  get value() {
    return toJS(this.state);
  }
  setValue(value: string, noURLUpdate = false) {
    this.state = value;
    if (!noURLUpdate) this.setValueToURLString();
  }
  resetValue(noURLUpdate = false) {
    this.setValue('', noURLUpdate);
  }
  setValueFromURLString() {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(this.queryName);
    if (paramValue) this.state = paramValue;
  }
  setValueToURLString() {
    const {
      location
    } = window;
    const urlParams = new URLSearchParams(location.search);
    urlParams.set(this.queryName, this.value);
    router.replace(`${location.origin + location.pathname}?${decodeURIComponent(urlParams.toString())}`, undefined, {
      scroll: false,
      shallow: true
    });
  }
  get queryURLString() {
    const urlParams = new URLSearchParams();
    urlParams.append(this.queryName, this.value);
    return decodeURI(urlParams.toString());
  }
}